<template>
  <div class="phonebox">
    <p>修改手机号</p>
    <div class="codebox">
      <input
        type="text"
        class="phone"
        @blur="checkPhone"
        v-model="newphone"
        placeholder="请输入手机号码"
        :error-message="errMsg.newmobilePhone"
      />
    </div>
    <div class="codebox">
      <input
        type="text"
        class="codeinp"
        v-model="newcode"
        placeholder="请输入验证码"
        :error-message="errMsg.captcha"
      />
      <span class="codetext" @click.prevent="getCode()"
        >|&nbsp;&nbsp; {{ newcaptchaText }}</span
      >
    </div>
    <p class="tishi" @click="chasouyzm">无法查收验证码？</p>
    <div class="btnbox">
      <van-button
        round
        block
        type="info"
        class="butout"
        :disabled="!newcode"
        @click="onSuccess()"
        native-type="submit"
        >确定修改
      </van-button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { SetGetAuthInfo } from '@/util/auth'
import { CHECK_MOBILE_PHONE } from '../../util/validate'
import {
  GetVerificationCode,
  updateWechatUserPhone
} from '../../api/user'
export default {
  data() {
    return {
      newphone: '',
      newcode: '',
      errMsg: {
        captcha: '',
        newmobilePhone: '',
        newcaptcha: ''
      },
      isDisable: false,
      isDisable2: false,
      newcaptchaText: '发送验证码'
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  mounted() {
    // this.newphone = this.userInfo.mobilePhone
  },
  methods: {
    chasouyzm() {
      this.$dialog.alert({
        message: '您可以联系「湖南爱民保」微信公众号官方客服登记解决'
      })
    },

    async getCode() {
      if (!this.newphone) {
        this.$notify({ type: 'danger', message: '请填写手机号' })
        return
      }
      if (!CHECK_MOBILE_PHONE(this.newphone)) {
        this.$notify({ type: 'danger', message: '手机号格式不正确' })
        return
      }
      if (this.isDisable2) {
        return
      }
      try {
        await GetVerificationCode({ mobilePhone: this.newphone })
        this.newcaptchaText = '获取中...'
        this.isDisable2 = true
        let countDown = 60
        this.newcaptchaText = `重新获取(${countDown})`
        this.veriInterval = setInterval(() => {
          countDown = countDown - 1
          if (countDown === 0) {
            clearInterval(this.veriInterval)
            this.isDisable2 = false
            this.newcaptchaText = `发送验证码`
          } else {
            this.newcaptchaText = `重新获取(${countDown})`
          }
        }, 1000)
      } catch (e) {
        this.$notify({ type: 'danger', message: e.message })
      }
    },
    checkPhone() {
      if (!this.newphone) {
        this.$notify({ type: 'danger', message: '请填写手机号码！' })
        return false
      } else if (!CHECK_MOBILE_PHONE(this.newphone)) {
        this.$notify({ type: 'danger', message: '手机号格式不正确！' })
        return false
      } else {
        // this.errMsg.newmobilePhone = ''
        return true
      }
    },
    checkVeriCode() {
      if (!this.newcode) {
        this.$notify({ type: 'danger', message: '验证码必填！' })
        return false
      }
      return true
    },
    async onSuccess() {
      if (this.checkPhone() && this.checkVeriCode()) {
        try {
          const res = await updateWechatUserPhone({
            openId: this.$store.state.userInfo.openId,
            oldPhone: this.userInfo.mobilePhone,
            newPhone: this.newphone,
            captcha: this.newcode
          })
          console.log(res)
          this.userInfo.mobilePhone = this.newphone
          SetGetAuthInfo.setInfo(this.userInfo)
          this.$store.commit('SET_USER_INFO', this.userInfo)
          // this.$router.push({ path: '/user-mean' })
          this.$router.go(-1)
        } catch (e) {
          console.log(e.message)
          var mess = ''
          if(e.message === '1001'){
            mess = '新旧手机号相同'
          }else if(e.message === '1002'){
            mess = '新换手机号与当前绑定手机号一致'
          }else if(e.message === '1003'){
            mess = '您的新手机号' + this.newphone + '已经与其他微信绑定，请更换手机号重试。'
          }else if(e.message === '1004'){
            mess = '您的新手机号' + this.newphone + '存在保单，请更换手机号重试。'
          }else{
            mess = e.message
          }
          this.$notify({ type: 'danger', message: mess })
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
.phonebox {
  padding: 50px 20px;
  .codebox {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    .codeinp {
      border: 0;
      background: 0;
      margin: 20px 0;
    }
    .phone {
      border: 0;
      font-size: 26px;
      background: 0;
      margin: 20px 0;
      width: 100%;
    }
    .codetext {
      color: royalblue;
      margin: 20px 0;
    }
  }
  .btnbox {
    margin: 40px auto;
    .butout {
      background: orange;
      border-color: orange;
    }
  }
}
.tishi {
  display: inline-block;
  font-size: 12px;
  color: #f00;
  float: right;
  margin: 20px 0;
}
</style>


